
export default function AboutUs() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left: Image */}
          <div className="relative">
            <div className="relative h-[600px] w-full rounded-lg overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/8e2da2ddbfa39af9bf357b8eb3f018c7.jpg"
                alt="Our team at work"
                className="w-full h-full object-cover object-center"
              />
            </div>
            {/* Accent Element */}
            <div className="absolute -bottom-6 -right-6 w-48 h-48 bg-orange-500 rounded-lg -z-10"></div>
          </div>

          {/* Right: Content */}
          <div>
            <div className="mb-6">
              <span className="text-orange-500 font-bold text-sm uppercase tracking-wider">
                Our Story
              </span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Built on <span className="text-orange-500">Friendship</span> &amp; Craftsmanship
            </h2>

            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p className="text-lg">
                Our journey started back in 2018 at Crenlo in Rochester, MN, where we met on the shop
                floor. What began as a working relationship quickly grew into a genuine friendship
                built on shared values and a passion for quality metalwork.
              </p>

              <p className="text-lg">
                Over the years, our bond strengthened through countless hunting and fishing trips, and
                we found ourselves constantly building—whether it was custom gear for the hunting
                property or helping friends with their projects. We realized we had something special:
                the skills, the drive, and the partnership to offer our community something better.
              </p>

              <p className="text-lg">
                The vision truly crystallized one crisp morning out in the woods. We were talking
                about building our own hunting blinds, and it hit us—if we could create something this
                solid for ourselves, why not bring that same craftsmanship and reliability to others?
                That conversation became the foundation of our business.
              </p>

              <p className="text-lg font-semibold text-gray-900">
                Today, we bring that same dedication to every weld, every fabrication, and every
                client. We're not just business partners—we're friends who genuinely care about
                delivering work we'd be proud to use ourselves.
              </p>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-6 mt-10 pt-10 border-t border-gray-200">
              <div>
                <div className="text-3xl font-bold text-orange-500 mb-1">2018</div>
                <div className="text-sm text-gray-600">Where It Started</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-orange-500 mb-1">500+</div>
                <div className="text-sm text-gray-600">Projects Completed</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-orange-500 mb-1">100%</div>
                <div className="text-sm text-gray-600">Commitment</div>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-10">
              <button
                onClick={() => {
                  // Safely trigger the sticky CTA button if it exists
                  const stickyBtn = document.querySelector<HTMLButtonElement>('#sticky-cta-btn');
                  if (stickyBtn) {
                    stickyBtn.click();
                  } else {
                    console.warn('Sticky CTA button not found');
                  }
                }}
                className="whitespace-nowrap bg-gray-900 hover:bg-orange-500 text-white font-bold text-base px-8 py-4 rounded-lg transition-all duration-300 cursor-pointer"
              >
                Work With Us
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
